import type { GameState } from "./GameState";
import { bus } from "../core/EventBus";

/**
 * Riesgos descubribles (puntos 11–12). Un riesgo se descubre mediante la
 * acción (inspección) y, una vez descubierto, permanece descubierto al
 * cargar partida.
 */
export class HazardManager {
  constructor(private state: GameState, private location: string) {}

  isDiscovered(hazardId: string): boolean {
    return this.state.chapter(this.location).hazards.includes(hazardId);
  }

  /** Devuelve true la primera vez que se descubre. */
  discover(hazardId: string): boolean {
    const ch = this.state.chapter(this.location);
    if (ch.hazards.includes(hazardId)) return false;
    ch.hazards.push(hazardId);
    this.state.persist();
    bus.emit("HAZARD_DISCOVERED", { hazardId });
    return true;
  }

  count(): number {
    return this.state.chapter(this.location).hazards.length;
  }
}
